import { useState } from "react";
import React, { forwardRef, useCallback } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./LoginFormModal.css";
import { supabase } from "../../apis/supabaseClient";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import PhoneInputWithCountrySelect from "react-phone-number-input";

const MYWONDER_URL = "https://mywonder.in/pages/my-wonder-companion";

function LoginFormModal({ show }) {
  const [step, setStep] = useState("phone");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});

  const handleSendOtp = async () => {
    const newErrors = {};
    if (!phone) newErrors.phone = true;
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    const { error } = await supabase.auth.signInWithOtp({ phone: phone });
    if (error) {
      alert("Failed to send OTP: " + error.message);
      return;
    }
    setStep("otp");
  };

  const handleVerifyOtp = async () => {
    const { data, error } = await supabase.auth.verifyOtp({
      phone,
      token: otp,
      type: "sms",
    });

    if (error) {
      alert("Invalid OTP: " + error.message);
      return;
    }
  };

  const CustomPhoneInput = useCallback(
    forwardRef(({ value, onChange, ...rest }, ref) => {
      return (
        <Form.Control
          ref={ref}
          type="tel"
          value={value || ""}
          onChange={onChange}
          className={errors.phone ? "input-error" : ""}
        />
      );
    }),
    [errors],
  );

  return (
    <>
      <Modal
        show={show}
        centered
        dialogClassName="custom-modal"
        data-bs-theme="light"
        size="lg"
      >
        <Modal.Header>
          <div style={{ width: "100%", textAlign: "center" }}>
            <Modal.Title
              style={{
                lineHeight: "1.2",
                marginBottom: "0px",
                fontSize: "2rem",
              }}
            >
              MyWonder Demo Site
            </Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="sub-header">
            <span className="sub-header-text">
              Experience conversational learning on MyWonder
            </span>
          </div>
          <Form>
            {(step === "phone" || step === "otp") && (
              <>
                <Form.Group className="mb-2" controlId="phone">
                  <Form.Label>Phone</Form.Label>
                  <PhoneInputWithCountrySelect
                    defaultCountry="IN"
                    value={phone}
                    onChange={setPhone}
                    className={errors.phone ? "input-error" : ""}
                    inputComponent={CustomPhoneInput}
                  />
                </Form.Group>
              </>
            )}
            {step === "otp" && (
              <>
                <Form.Group className="mb-2" controlId="otp">
                  <Form.Label>OTP</Form.Label>
                  <Form.Control
                    type="tel"
                    name="otp"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className={errors.otp ? "input-error" : ""}
                  />
                </Form.Group>
              </>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer className="w-100 mb-3 d-flex justify-content-center">
          <Button
            onClick={step === "phone" ? handleSendOtp : handleVerifyOtp}
            className="submit-button"
          >
            {step === "phone" && "Send OTP"}
            {step === "otp" && "Login"}
          </Button>
          <div className="usage-disclaimer">
            <span>
              Note: For demo, conversation is limited to 5 minutes per day.{" "}
              <a
                className="usage-disclaimer-link"
                href={MYWONDER_URL}
                target="_blank"
                rel="noreferrer"
              >
                MyWonder Launch Pack
              </a>{" "}
              comes with 2500 minutes talktime.
            </span>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LoginFormModal;
